import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Csidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Cifelse(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
 <title>Else if in c tutorial For Beginners</title>
 <meta name="description" content="else if in c tutorial for beginners.when if condition is true so on that time target of the will be executed. CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,programming language,tutorial for begineers,if else,if,else if,c programming tutorial for beginners,learn code in free online,c if else statement,c if else program,c if else example,c if else shorthand,c program with if else,c programming if else exercises,nested if else statement in c,c programming if else example pdf,c programming nested if else exercises,c programming if else questions,c programming if else example,c program using if else,c language if else programs" />
 <link rel="canonical" href="https://www.codeexampler.com/c-if-else" />
 </Helmet>

 <div className='lg:pl-56'>

    <h1 className="m-4 mh1">Else if statement in c </h1>
   
    <div className="first">
        <a href="/c-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
   
    <h2 className="mt-4 mh2">The syntax for if-else in a C programming language:</h2>

  

       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
            {"\n"}
                <span className="qwerty-6">if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-10">conditon</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" > &#123; </span>
            {"\n"}
                  <span className="qwerty-3">   statement</span>
                  <span className="qwerty-4">;</span>
                  {"\n"}
                <span className="qwerty-4" > &#125;</span>       
            {"\n"}
            <span className="qwerty-6">else </span>
                  {"\n"}
                <span className="qwerty-4" > &#123; </span>
            {"\n"}
                  <span className="qwerty-3">   statement</span>
                  <span className="qwerty-4">;</span>
                  {"\n"}
                <span className="qwerty-4" > &#125;</span>       
                {"\n"} {"\n"}
               
                 </code>
        </pre>
        </div>   


<p className="mt-4 para">If a condition is true, so on that time target will be executed, but if the condition is false if it exists and the mark of the else will be running.</p>
<h2 className="mt-4 mh2">If else in C example:</h2>




<h2 className='headings'>Q-Write a program to imput a number and check this value is greater than  1000 or not?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
          <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   int </span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">;</span>            
            {"\n"}               
            <span className="qwerty-7">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> Enter a no </span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%d</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">a </span>
            <span className="qwerty-4">);</span>
                   {"\n"}{"\n"}       
                <span className="qwerty-6">   if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty">&#62;</span>
                <span className="qwerty-1">1000</span>
                <span className="qwerty-4">) </span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-7">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> a is greater than 1000 </span>
                <span className="qwerty-4">");</span>
            {"\n"}
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}
                <span className="qwerty-6">   else </span>
                            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}       
            <span className="qwerty-7">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> a is lesser than 1000 </span>
                <span className="qwerty-4">");</span>
            {"\n"}
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}     
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-5">Enter a no</span>                   
                  <span className="qwerty-1"> 542</span>                   
                  {"\n"}   {"\n"}                  
                  <span className="qwerty-3">a</span>                   
                  <span className="qwerty-5"> is lesser than</span>                   
                  <span className="qwerty-1"> 1000</span>                   
                  {"\n"}   {"\n"} 
                  </code>
                  </pre>
                  </div>    
   

<p className="mt-4 para">If you don't know about input in C so check on the <a href="https://www.codeexampler.com/c-input">C input tutorial</a>.</p>


<h2 className='headings'>Q-Write a program to check a no is even or odd?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
         {"\n"}
         <span className="qwerty-7">#include </span>
               <span className="qwerty-4">&#60;</span>
               <span className="qwerty-10">stdio.h</span>
               <span className="qwerty-4">&#62; </span>
                       {"\n"}
               <span className="qwerty-3">int </span>
               <span className="qwerty-2">main</span>
               <span className="qwerty-4"> ()</span>            
                       {"\n"}   
                       <span className="qwerty-4" > &#123; </span>             
                       {"\n"}
               <span className="qwerty-3">   int </span>
               <span className="qwerty-5">a</span>
               <span className="qwerty-4">;</span>            
           {"\n"}               
           <span className="qwerty-7">   printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> Enter a value </span>
               <span className="qwerty-4">");</span>
           {"\n"}
           <span className="qwerty-6">   scanf</span>
           <span className="qwerty-4">("</span>
           <span className="qwerty-3">%d</span>
           <span className="qwerty-4">",</span>
           <span className="qwerty-1"> &amp;</span>
           <span className="qwerty-5">a </span>
           <span className="qwerty-4">);</span>
                  {"\n"}{"\n"}       
               <span className="qwerty-6">   if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">a</span>
               <span className="qwerty">%</span>
               <span className="qwerty-1">2</span>
               <span className="qwerty"> == </span>
               <span className="qwerty-1">0</span>
               <span className="qwerty-4">) </span>
           {"\n"}
               <span className="qwerty-4" >   &#123; </span>
           {"\n"}          
           <span className="qwerty-7">    printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> a is even </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}
               <span className="qwerty-6">   else </span>
                           {"\n"}
               <span className="qwerty-4" >   &#123; </span>
           {"\n"}       
           <span className="qwerty-7">    printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> a is odd </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}     
           <span className="qwerty-7">   return</span>
               <span className="qwerty-3"> 0</span>
               <span className="qwerty-4">; </span>
           {"\n"}            
               <span className="qwerty-4"> &#125;</span>
               {"\n"}      {"\n"} 
                </code>
       </pre>
       </div>
       <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
         <pre style={{maxHeight:"100vh"}}>
               <code >                  
               {"\n"}      
                 <span className="qwerty-5">Enter a value</span>                   
                 <span className="qwerty-1"> 46</span>                   
                 {"\n"}   {"\n"}                  
                 <span className="qwerty-8">a</span>                   
                 <span className="qwerty-5"> is even</span>                   
                 {"\n"}   {"\n"} 
                 </code>
                 </pre>
                 </div>  





<h2 className='headings'>Q-Write a program to check a no vowels by using a character?</h2>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
      <pre style={{maxHeight:"500vh"}}>
          <code >
          {"\n"}
                <span className="qwerty-7">#include </span>
                <span className="qwerty-4">&#60;</span>
                <span className="qwerty-10">stdio.h</span>
                <span className="qwerty-4">&#62; </span>
                        {"\n"}
                <span className="qwerty-3">int </span>
                <span className="qwerty-2">main</span>
                <span className="qwerty-4"> ()</span>            
                        {"\n"}   
                        <span className="qwerty-4" > &#123; </span>             
                        {"\n"}
                <span className="qwerty-3">   char </span>
                <span className="qwerty-5">cha</span>
                <span className="qwerty-4">;</span>            
            {"\n"}               
            <span className="qwerty-7">   printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2"> Enter a character \n</span>
                <span className="qwerty-4">");</span>
            {"\n"}
            <span className="qwerty-6">   scanf</span>
            <span className="qwerty-4">("</span>
            <span className="qwerty-3">%c</span>
            <span className="qwerty-4">",</span>
            <span className="qwerty-1"> &amp;</span>
            <span className="qwerty-5">cha</span>
            <span className="qwerty-4">);</span>
                   {"\n"}
                <span className="qwerty-6">   if </span>
                <span className="qwerty-4">(</span>
                <span className="qwerty-5">cha</span>
                <span className="qwerty">== </span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-5">a</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-4">||</span>
                <span className="qwerty-5">cha</span>
                <span className="qwerty"> ==</span>
                <span className="qwerty-4"> '</span>
                <span className="qwerty-5">e</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-4"> || </span>                
                <span className="qwerty-5">cha</span>
                <span className="qwerty">==</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-5">i</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-4"> || </span>                
                <span className="qwerty-5">cha</span>
                <span className="qwerty">==</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-5">o</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-4"> || </span>                                
                <span className="qwerty-5">cha</span>
                <span className="qwerty">==</span>
                <span className="qwerty-4">'</span>
                <span className="qwerty-5">u</span>
                <span className="qwerty-4">')</span>
            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}          
            <span className="qwerty-7">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">use vowels in this character</span>
                <span className="qwerty-4">");</span>
            {"\n"}
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}
                <span className="qwerty-6">   else </span>
                            {"\n"}
                <span className="qwerty-4" >   &#123; </span>
            {"\n"}       
            <span className="qwerty-7">    printf</span>
                <span className="qwerty-4">("</span>
                <span className="qwerty-2">no use of vowels in this character</span>
                <span className="qwerty-4">");</span>
            {"\n"}
                  <span className="qwerty-4" >   &#125;</span>       
            {"\n"}     
            <span className="qwerty-7">   return</span>
                <span className="qwerty-3"> 0</span>
                <span className="qwerty-4">; </span>
            {"\n"}            
                <span className="qwerty-4"> &#125;</span>
                {"\n"}      {"\n"} 
                 </code>
        </pre>
        </div>
        <h4 className='headings'>Output :</h4>
        <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
          <pre style={{maxHeight:"100vh"}}>
                <code >                  
                {"\n"}      
                  <span className="qwerty-10">Enter a character</span>                   
                  <span className="qwerty-1"> i</span>                   
                  {"\n"}   {"\n"}                                
                  <span className="qwerty-4">use of vowels in this character</span>                   
                  {"\n"}   {"\n"} 
                  </code>
                  </pre>
                  </div> 

<h2 className="mt-4 mh2">If you print two no in c so use the short method:
</h2>
<p className="mt-4 para">int a,b;<br/>
Printf(“enter a no”);<br/>
Scanf(“%d”,&#38;a);<br/>
Printf(“enter b no”);<br/>
Scanf(“%d”,&#38;b);<br/>

Or <br/>
Int a,b;<br/>
Printf(”enter a and b value”);<br/>
Scanf(“%d%d”,&#38;a,&#38;b);<br/>
</p>



<h2 className='headings'>Q-Write a program to which no is greater between two numbers?</h2>
     <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
    <pre style={{maxHeight:"500vh"}}>
        <code >
        {"\n"}
        <span className="qwerty-7">#include </span>
              <span className="qwerty-4">&#60;</span>
              <span className="qwerty-10">stdio.h</span>
              <span className="qwerty-4">&#62; </span>
                      {"\n"}
              <span className="qwerty-3">int </span>
              <span className="qwerty-2">main</span>
              <span className="qwerty-4"> ()</span>            
                      {"\n"}   
                      <span className="qwerty-4" > &#123; </span>             
                      {"\n"}
              <span className="qwerty-3">   int </span>
              <span className="qwerty-5">a</span>
              <span className="qwerty-4">;</span>            
          {"\n"}               
          <span className="qwerty-7">   printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-2">Enter 1 no</span>
              <span className="qwerty-4">");</span>
          {"\n"}
          <span className="qwerty-6">   scanf</span>
          <span className="qwerty-4">("</span>
          <span className="qwerty-3">%d</span>
          <span className="qwerty-4">",</span>
          <span className="qwerty-1"> &amp;</span>
          <span className="qwerty-5">a </span>
          <span className="qwerty-4">);</span>
                 {"\n"}     
          <span className="qwerty-7">   printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-2">Enter 2 no</span>
              <span className="qwerty-4">");</span>
          {"\n"}
          <span className="qwerty-6">   scanf</span>
          <span className="qwerty-4">("</span>
          <span className="qwerty-3">%d</span>
          <span className="qwerty-4">",</span>
          <span className="qwerty-1"> &amp;</span>
          <span className="qwerty-5">b </span>
          <span className="qwerty-4">);</span>
                 {"\n"}{"\n"}       
              <span className="qwerty-6">   if </span>
              <span className="qwerty-4">(</span>
              <span className="qwerty-5">a</span>
              <span className="qwerty-4">&#60;</span>
              <span className="qwerty-5">b</span>
              <span className="qwerty-4">) </span>
          {"\n"}
              <span className="qwerty-4" >   &#123; </span>
          {"\n"}          
          <span className="qwerty-7">    printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-2">Greater = </span>
              <span className="qwerty-3">%d</span>
              <span className="qwerty-4">",</span>
              <span className="qwerty-5"> a</span>
              <span className="qwerty-4">);</span>
          {"\n"}
                <span className="qwerty-4" >   &#125;</span>       
          {"\n"}
              <span className="qwerty-6">   else </span>
                          {"\n"}
              <span className="qwerty-4" >   &#123; </span>
          {"\n"}       
          <span className="qwerty-7">    printf</span>
              <span className="qwerty-4">("</span>
              <span className="qwerty-2">Greater = </span>
              <span className="qwerty-3">%d</span>
              <span className="qwerty-4">",</span>
              <span className="qwerty-5"> b</span>
              <span className="qwerty-4">");</span>
          {"\n"}
                <span className="qwerty-4" >   &#125;</span>       
          {"\n"}     
          <span className="qwerty-7">   return</span>
              <span className="qwerty-3"> 0</span>
              <span className="qwerty-4">; </span>
          {"\n"}            
              <span className="qwerty-4"> &#125;</span>
              {"\n"}      {"\n"} 
               </code>
      </pre>
      </div>
      <h4 className='headings'>Output :</h4>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
        <pre style={{maxHeight:"500vh"}}>
              <code >                  
                {"\n"}      
                <span className="qwerty-5">Enter 1 no</span>                   
                <span className="qwerty-1"> 24</span>                   
                {"\n"}                     
                <span className="qwerty-5">Enter 2 no</span>                   
                <span className="qwerty-1"> 12</span>                   
                {"\n"}                   
                <span className="qwerty-5">Greater = </span>                   
                <span className="qwerty-3"> 24</span>                   
                {"\n"}  
                {"\n"}    
                </code>
                </pre>
                </div> 

<h2 className="mt-4 mh2">Nested if statement in c</h2>
<p className="mt-4 para"> If we write an entire if-else construct within either the body of the if statement or an else statement. That is called nesting if a list or nested if statement in c<br/>

</p>




<h2 className='headings'>Q-Write a program to input a no and check the nested list?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
         {"\n"}
         <span className="qwerty-7">#include </span>
               <span className="qwerty-4">&#60;</span>
               <span className="qwerty-10">stdio.h</span>
               <span className="qwerty-4">&#62; </span>
                       {"\n"}
               <span className="qwerty-3">int </span>
               <span className="qwerty-2">main</span>
               <span className="qwerty-4"> ()</span>            
                       {"\n"}   
                       <span className="qwerty-4" > &#123; </span>             
                       {"\n"}
               <span className="qwerty-3">   int </span>
               <span className="qwerty-5">a</span>
               <span className="qwerty-4">;</span>            
           {"\n"}               
           <span className="qwerty-7">   printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> Enter a value </span>
               <span className="qwerty-4">");</span>
           {"\n"}
           <span className="qwerty-6">   scanf</span>
           <span className="qwerty-4">("</span>
           <span className="qwerty-3">%d</span>
           <span className="qwerty-4">",</span>
           <span className="qwerty-1"> &amp;</span>
           <span className="qwerty-5">a </span>
           <span className="qwerty-4">);</span>
                  {"\n"}{"\n"}       
               <span className="qwerty-6">   if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">i</span>
               <span className="qwerty">&#60;=</span>
               <span className="qwerty-1">100</span>
               <span className="qwerty-4">) </span>
           {"\n"}
               <span className="qwerty-4" >   &#123; </span>
           {"\n"}          
           <span className="qwerty-7">    printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">no is less than 100 </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >   &#123;</span>       
           {"\n"}
               <span className="qwerty-6">   else </span>
                           {"\n"}
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}
                           
               <span className="qwerty-6">    if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">i</span>
               <span className="qwerty">&#62;=</span>
               <span className="qwerty-1">1000</span>
               <span className="qwerty-4">) </span>
           {"\n"}
               <span className="qwerty-4" >    &#123; </span>
           {"\n"}          
           <span className="qwerty-7">     printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">greater than 1000 </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4">    &#125;</span>       
           {"\n"}
           <span className="qwerty-6">    else </span>
                           {"\n"}       
               <span className="qwerty-4" >    &#123; </span>
           {"\n"}       
           <span className="qwerty-7">     printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">bw </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >    &#125;</span>       
           {"\n"}     
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}     
           <span className="qwerty-7">   return</span>
               <span className="qwerty-3"> 0</span>
               <span className="qwerty-4">; </span>
           {"\n"}            
               <span className="qwerty-4"> &#125;</span>
               {"\n"}      {"\n"} 
                </code>
       </pre>
       </div>
       <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
         <pre style={{maxHeight:"100vh"}}>
               <code >                  
               {"\n"}      
                 <span className="qwerty-5">Enter a value</span>                   
                 <span className="qwerty-1"> 4800</span>                   
                 {"\n"}   {"\n"}                  
                 <span className="qwerty-5">greater than</span>                   
                 <span className="qwerty-1"> 1000</span>                   
                 {"\n"}   {"\n"} 
                 </code>
                 </pre>
                 </div>  



<h2 className='headings'>Q-Write a program to check gender inside the nested list in C?</h2>
      <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}} >
     <pre style={{maxHeight:"500vh"}}>
         <code >
         {"\n"}
         <span className="qwerty-7">#include </span>
               <span className="qwerty-4">&#60;</span>
               <span className="qwerty-10">stdio.h</span>
               <span className="qwerty-4">&#62; </span>
                       {"\n"}
               <span className="qwerty-3">int </span>
               <span className="qwerty-2">main</span>
               <span className="qwerty-4"> ()</span>            
                       {"\n"}   
                       <span className="qwerty-4" > &#123; </span>             
                       {"\n"}
               <span className="qwerty-3">   char </span>
               <span className="qwerty-5">sex</span>
               <span className="qwerty-4">;</span>            
           {"\n"}               
           <span className="qwerty-7">   printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2"> Enter the Gender </span>
               <span className="qwerty-4">");</span>
           {"\n"}
           <span className="qwerty-6">   scanf</span>
           <span className="qwerty-4">("</span>
           <span className="qwerty-3">%c</span>
           <span className="qwerty-4">",</span>
           <span className="qwerty-1"> &amp;</span>
           <span className="qwerty-5">sex </span>
           <span className="qwerty-4">);</span>
                  {"\n"}{"\n"}       
               <span className="qwerty-6">   if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">i</span>
               <span className="qwerty">=='</span>
               <span className="qwerty-1">m</span>
               <span className="qwerty-4">') </span>
           {"\n"}
               <span className="qwerty-4" >   &#123; </span>
           {"\n"}          
           <span className="qwerty-7">    printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">Male </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >   &#123;</span>       
           {"\n"}
               <span className="qwerty-6">   else </span>
                           {"\n"}
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}
                           
               <span className="qwerty-6">    if </span>
               <span className="qwerty-4">(</span>
               <span className="qwerty-5">i</span>
               <span className="qwerty">=='</span>
               <span className="qwerty-1">f</span>
               <span className="qwerty-4">') </span>
           {"\n"}
               <span className="qwerty-4" >    &#123; </span>
           {"\n"}          
           <span className="qwerty-7">     printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">Female </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4">    &#125;</span>       
           {"\n"}
           <span className="qwerty-6">    else </span>
                           {"\n"}       
               <span className="qwerty-4" >    &#123; </span>
           {"\n"}       
           <span className="qwerty-7">     printf</span>
               <span className="qwerty-4">("</span>
               <span className="qwerty-2">not Male and not Female </span>
               <span className="qwerty-4">");</span>
           {"\n"}
                 <span className="qwerty-4" >    &#125;</span>       
           {"\n"}     
                 <span className="qwerty-4" >   &#125;</span>       
           {"\n"}     
           <span className="qwerty-7">   return</span>
               <span className="qwerty-3"> 0</span>
               <span className="qwerty-4">; </span>
           {"\n"}            
               <span className="qwerty-4"> &#125;</span>
               {"\n"}      {"\n"} 
                </code>
       </pre>
       </div>
       <h4 className='headings'>Output :</h4>
       <div style = {{ background:"#0f0e33",width:"94%",marginLeft:"3%",paddingLeft:"2%",borderRadius: "20px"}}>
         <pre style={{maxHeight:"100vh"}}>
               <code >                  
               {"\n"}      
                 <span className="qwerty-5">Enter the Gender</span>                   
                 <span className="qwerty-1"> f</span>                   
                 {"\n"}   {"\n"}                  
                 <span className="qwerty-3">Female</span>                   
                     {"\n"}   {"\n"} 
                 </code>
                 </pre>
                 </div> 


<h1 className="mt-5">  </h1>
<div className="back">
        <a href="/c-if">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/c-if-else-if">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Cifelse;